/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import {
  navigateTo,
  isSomething,
  ItemMenu,
  ListItem,
  Picture,
  FormattedRelativeTime,
  url,
  handleUnknownErrors,
  fetchAccessRights,
  ConfirmationModal,
  showSuccess,
  parseISO8601Date,
  withFlipper,
} from "lcm-iot-commons";
import { MenuItem } from "react-bootstrap";
import {
  edgeDeviceStatus,
  edgeDeviceIconClassName,
} from "../../utils/statusUtils";
import { edgeDeviceShape } from "../../shapes/edgeDevicesShape";
import { removeEdgeDevice } from "../../api";
import { getEdgeDeviceImageUrl } from "./PicturePoolUrl";

type OwnProps = {
  edgeDevice?: edgeDeviceShape;
  showItemMenu?: boolean;
  intl?: {
    formatMessage?: $TSFixMeFunction;
  };
  onEdgeDeviceRemove?: $TSFixMeFunction;
  flipper: {
    edgeDeviceLateBinding?: boolean;
  };
  showDelete?: boolean;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  showItemMenu: false,
  edgeDevice: undefined,
  intl: undefined,
  onEdgeDeviceRemove: () => {},
  showDelete: false,
};

type Props = OwnProps & typeof defaultProps;

export class EdgeDeviceItem extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static readonly defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnEditClick = this.handleOnEditClick.bind(this);
    this.handleOnDeleteClick = this.handleOnDeleteClick.bind(this);
    this.handleOnConfirm = this.handleOnConfirm.bind(this);
    this.handleOnModalClose = this.handleOnModalClose.bind(this);
    this.handleOnItemMenuOpen = this.handleOnItemMenuOpen.bind(this);

    this.state = { accessRights: undefined, deleting: false };
  }

  async handleOnItemMenuOpen() {
    const { intl, edgeDevice } = this.props;
    const accessRightsED = await fetchAccessRights(
      "EDM::EdgeDevice",
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      edgeDevice.id,
    ).catch((errors) =>
      handleUnknownErrors(
        errors,
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({ id: "api.error.unknown" }),
      ),
    );
    this.setState({
      accessRights: accessRightsED,
    });
  }

  handleOnEditClick() {
    const { edgeDevice } = this.props;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    navigateTo(`/edge_devices/${edgeDevice.id}/edit`);
  }

  handleOnDeleteClick() {
    this.setState({ deleting: true });
  }

  async handleOnConfirm() {
    const { edgeDevice, intl, onEdgeDeviceRemove } = this.props;
    this.resetActionsState();

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    removeEdgeDevice(edgeDevice.id)
      .then(() => {
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        onEdgeDeviceRemove(edgeDevice);
        showSuccess(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({ id: "edge_device.delete.successful" }),
          // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
          true,
        );
      })
      .catch((errors) =>
        handleUnknownErrors(
          errors,
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          intl.formatMessage({ id: "api.error.unknown" }),
        ),
      );
  }

  handleOnModalClose() {
    this.resetActionsState();
  }

  resetActionsState() {
    this.setState({
      deleting: false,
    });
  }

  getLastSeenTextColor = (edgeDevice: $TSFixMe) =>
    edgeDeviceStatus(
      edgeDevice.status.code,
      parseISO8601Date(edgeDevice.lastSeenAt),
    ) === "critical"
      ? "lastseen-offline"
      : "";

  getEdgeDeviceConnectityString = (edgeDevice: $TSFixMe) =>
    `Connectivity: ${this.removeParentheses(edgeDevice.addOn.name)}`;

  removeParentheses(str: $TSFixMe) {
    return str.replace(/\s*\(.*?\)\s*/g, "").trim();
  }

  formatDetails(edgeDevice: $TSFixMe) {
    if (
      edgeDevice.status.code === "registered" ||
      edgeDevice.status.code === "offline"
    ) {
      return (
        <div>
          {edgeDevice.addOn?.name
            ? this.getEdgeDeviceConnectityString(edgeDevice)
            : ""}
          {edgeDevice.addOn?.name ? " " : ""}
          {edgeDevice.addOn?.name ? <br /> : ""}
          <span>
            <FormattedMessage id="label.last_seen" />
            {": "}
            {edgeDevice.lastSeenAt ? (
              <span className={this.getLastSeenTextColor(edgeDevice)}>
                <FormattedRelativeTime
                  value={new Date(edgeDevice.lastSeenAt)}
                />
              </span>
            ) : /* istanbul ignore next */ null}
          </span>
        </div>
      );
    }
    return (
      <div>
        {edgeDevice.addOn?.name
          ? this.getEdgeDeviceConnectityString(edgeDevice)
          : ""}
        {edgeDevice.addOn?.name ? " " : ""}
        {edgeDevice.addOn?.name ? <br /> : ""}
        {/* @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1. */}
        <span className={edgeDeviceStatus(edgeDevice.status.code)} />
        {edgeDevice.status.name}
      </div>
    );
  }

  render() {
    const { edgeDevice, showItemMenu, intl, flipper, showDelete } = this.props;
    const { accessRights, deleting } = this.state;
    const canEdit = accessRights ? accessRights.canUpdate : false;
    const canDelete = accessRights ? accessRights.canPermit : false;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const hasUplinkAddOn = edgeDevice.addOn?.product_code === "uplink";
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    let headerText = edgeDevice.serialNumber
      .concat(" - ")
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      .concat(edgeDevice.type.name);
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    if (isSomething(edgeDevice.name)) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      headerText = `${edgeDevice.name} - ${headerText}`;
    }

    return (
      <ListItem
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        id={`ed-item-${edgeDevice.serialNumber}`}
        image={
          <Picture
            width={50}
            height={50}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            src={getEdgeDeviceImageUrl(edgeDevice.type.code, 50)}
            // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
            placeholder={edgeDeviceIconClassName(edgeDevice)}
          />
        }
        title={headerText}
        status={edgeDeviceStatus(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          edgeDevice.status.code,
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          parseISO8601Date(edgeDevice.lastSeenAt),
        )}
        description={this.formatDetails(edgeDevice)}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        target={url(`/edge_devices/${edgeDevice.id}`)}
        actions={
          <>
            {showItemMenu ? (
              // @ts-expect-error TS(2322) FIXME: Type '{ children: (Element | null)[]; id: string; ... Remove this comment to see the full error message
              <ItemMenu id="item-menu" onOpen={this.handleOnItemMenuOpen}>
                <MenuItem
                  id="item-edit"
                  disabled={!canEdit}
                  onSelect={this.handleOnEditClick}
                >
                  <FormattedMessage id="button.edit" />
                </MenuItem>
                {showDelete ||
                (hasUplinkAddOn && flipper.edgeDeviceLateBinding) ? (
                  <MenuItem
                    id="item-remove"
                    disabled={!canDelete}
                    onSelect={this.handleOnDeleteClick}
                  >
                    <FormattedMessage id="edge_device.delete" />
                  </MenuItem>
                ) : null}
              </ItemMenu>
            ) : null}
            {deleting ? (
              <ConfirmationModal
                id="confirmation-modal"
                show
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                titleText={intl.formatMessage({
                  id: "edge_device.delete.modal_header",
                })}
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                messageText={intl.formatMessage({
                  id: "edge_device.delete.modal_message",
                })}
                onConfirm={this.handleOnConfirm}
                onClose={this.handleOnModalClose}
              />
            ) : null}
          </>
        }
      />
    );
  }
}

export default withFlipper(EdgeDeviceItem);
